import { createSelector } from 'reselect';

const selectDBNCategoryAccountMappings = (state: any) => state.dbnCategoryAccountMappings;


export const selectDBNCategoryAccountMappingsCurrentItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.current);

export const selectDBNCategoryAccountMappingsListItems = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.list);

export const selectDBNCategoryAccountMappingsItemById = (itemId: any) =>
    createSelector(selectDBNCategoryAccountMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBNCategoryAccountMappingsQueryItems = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.query);

export const selectDBNCategoryAccountMappingsCreatedItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.create);

export const selectDBNCategoryAccountMappingsUpdatedItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.update);

export const selectDBNCategoryAccountMappingsReadItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.read);

export const selectDBNCategoryAccountMappingsDeletedItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.delete);

export const selectDBNCategoryAccountMappingsPublishedItem = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.publish);

export const selectDBNCategoryAccountMappingsearchedItems = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.search);

export const selectDBNCategoryAccountMappingsItemsCount = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.count);

export const selectDBNCategoryAccountMappingsItemsFilter = createSelector([selectDBNCategoryAccountMappings], (dbnCategoryAccountMappings) => dbnCategoryAccountMappings.filter);